module.exports = __webpack_public_path__ + "static/media/flowability.ae2b0126.png";